export default __webpack_public_path__ + "static/budget-planner-c8337a4781c88bd69e3bbef90c6ad636.webp";